import React, { Component } from 'react'
import g, { Span } from 'glamorous'
import moment from 'moment';
import Swiper from 'react-id-swiper'
import 'react-id-swiper/src/styles/css/swiper.css'

import TeamInDate from './team-in-date-fragm'
import CardViews from './card-views-fragm'

import './styles/index.scss'

class CountryView extends Component {

    getTeamsByGroupId(groupId) {
        const { teams } = this.props.nodes.data.matchSchedule;
        return teams.filter(tm => tm.group.id === groupId).sort((a, b) => (a.group.position - b.group.position))
    }

    getMatchsByGroupIdAndDateId(groupId, dateId) {
        const { matchs, teams } = this.props.nodes.data.matchSchedule
        let fTeam = teams.filter(tm => tm.isoalph3 === this.props.currentCountryCode)
        let tMatchs = []
        if (fTeam.length > 0) {
            let team = fTeam[0]
            tMatchs = matchs.filter(mt =>  ((mt.leftTeam.groupId === team.group.id && mt.leftTeam.position === team.group.position) || (mt.rightTeam.groupId === team.group.id &&  mt.rightTeam.position === team.group.position)))
                            .filter(mt => mt.dateId === dateId && mt.groupId === groupId)
            
        }           

        return tMatchs
    }

    getOneTeamByGroupIdAndPosition(groupId, positionId) {
        const { teams } = this.props.nodes.data.matchSchedule;
        let rteams = teams.filter(tm => tm.group.id === groupId && tm.group.position === positionId)
        return rteams.length > 0 ? rteams[rteams.length - 1] : 
        { 
            id: 9999, 
            flag: 'default.png', 
            isoalph3: groupId+positionId, 
            name: groupId+positionId,
            "player": {
                "name": "",
                "earnings": 0,
                "pic": "default.png"
            },
            "food": {
                "name": "",
                "calories": 0,
                "pic": "default.png"
            },
            "beverage": {
                "name": "",
                "alcoholProof": 0,
                "pic": "default.png"
            }
        }
    }

    getOneMatchById(matchId) {
        const { matchs } = this.props.nodes.data.matchSchedule
        let rmatchs = matchs.filter(mt => mt.id === parseInt(matchId, 0))
        return rmatchs.length > 0 ? rmatchs[rmatchs.length - 1] : null
    }

    getOneStadiumById(stadiumId) {
        const { stadiums } = this.props.nodes.data.matchSchedule
        let rstadiums = stadiums.filter(st => st.id === stadiumId)
        return rstadiums.length > 0 ? rstadiums[rstadiums.length - 1] : null
    }

    getOneGroupByCountryCode(countryCode) {
        const { teams } = this.props.nodes.data.matchSchedule
        let rGroups = teams.filter(tm => tm.isoalph3 === countryCode).map(tm => { return {id: tm.group.id, name: `GRUPO ${tm.group.id}` } })
        return rGroups
    }

    formatUTCMatchDate(datetimeUTC, format) {
        return moment(parseInt(datetimeUTC, 0)).format(format)
    }

	render() {          
		const { dates, defaults } = this.props.nodes.data.matchSchedule
        const currentMatch = this.getOneMatchById(this.props.currentMatchId)
        const currentLeftTeam = this.getOneTeamByGroupIdAndPosition(currentMatch.leftTeam.groupId, currentMatch.leftTeam.position)
        const currentRightTeam = this.getOneTeamByGroupIdAndPosition(currentMatch.rightTeam.groupId, currentMatch.rightTeam.position)
        const currentStadium = this.getOneStadiumById(currentMatch.stadiumId)

        return (
            <g.Div className="uvn-fifa2018-group-view">
                <g.Ul>
                    {
                        this.getOneGroupByCountryCode(this.props.currentCountryCode).map((gr, grk) => {
                            return (
                                <g.Li key={grk} id={`${grk}${gr.id}`}  className="uvn-fifa2018-group-view-item uvn-fifa2018-group-view-item-selected">
                                    <g.Div className="container-teams-name">
                                        <g.Div className="name">
                                            <g.Span>{gr.name}</g.Span>
                                            <g.H2 display="none">{gr.name}</g.H2>
                                        </g.Div>
                                        <g.Div className="teams">
                                            <g.Ul>
                                                {
                                                    this.getTeamsByGroupId(gr.id).map((tm, tmk) => {
                                                        return (<g.Li key={tmk}>
                                                                    <g.Img src={require(`./images/flags/${tm.flag}`)} className="flag-team" />
                                                                    <g.Span className="name-team-short">{tm.isoalph3}</g.Span>
                                                                    <g.Span className="name-team-large">{tm.name}</g.Span>
                                                                </g.Li>)
                                                    })
                                                }
                                            </g.Ul>
                                        </g.Div>
                                    </g.Div>
                                    <g.Div className="dates">
                                        <g.Ul>
                                            {
                                                dates.map((dt, dtk) => {
                                                    return (
                                                        <g.Li key={dtk}>
                                                            <g.Div className="title-date">{dt.name}</g.Div>
                                                            <g.H2 display="none">{dt.name}</g.H2>
                                                            <g.Ul className="list-dates">
                                                                {
                                                                    this.getMatchsByGroupIdAndDateId(gr.id, dt.id).map((mt, mtk) => {
                                                                        return (
                                                                            <g.Li key={mtk}
                                                                                  cursor="pointer"
                                                                                  className={mt.id === currentMatch.id ? 'selected' : ''}
                                                                                  onClick={() => this.props.gotomatch(mt.id)}>
                                                                                <g.Div className="content-info-date">
                                                                                    <g.Div className="date-string">{this.formatUTCMatchDate(mt.datetimeUTC, 'DD/MM/YYYY')}</g.Div>
                                                                                    <g.H3 display="none">{this.getOneTeamByGroupIdAndPosition(mt.leftTeam.groupId, mt.leftTeam.position).name} VS {this.getOneTeamByGroupIdAndPosition(mt.rightTeam.groupId, mt.rightTeam.position).name}</g.H3>
                                                                                    <TeamInDate
                                                                                        className="team-left"                                                                                        
                                                                                        team={this.getOneTeamByGroupIdAndPosition(mt.leftTeam.groupId, mt.leftTeam.position)} />
                                                                                    <g.Div className="vs">VS</g.Div>
                                                                                    <TeamInDate
                                                                                        className="team-right"
                                                                                        team={this.getOneTeamByGroupIdAndPosition(mt.rightTeam.groupId, mt.rightTeam.position)} />                                                                                    
                                                                                </g.Div>
                                                                            </g.Li>
                                                                        )
                                                                    })
                                                                }
                                                            </g.Ul>
                                                        </g.Li>
                                                    )
                                                })
                                            }
                                        </g.Ul>
                                    </g.Div>
                                    {
                                        (currentMatch !== null && currentMatch.groupId === gr.id) &&
                                        <CardViews
                                            currentLeftTeam={currentLeftTeam}
                                            currentRightTeam={currentRightTeam}
                                            currentMatch={currentMatch}
                                            defaults={defaults}
                                            currentStadium={currentStadium}
                                            cardIndex={this.props.cardIndex}
                                            gotocard={this.props.gotocard}
                                            emphasysCard={this.props.emphasysCard} />
                                    }
                                </g.Li>)
                        })
                    }
                </g.Ul>
			</g.Div>)
	}
}

export default CountryView


// WEBPACK FOOTER //
// ./src/components/calendar/country-view.js